var _rect, _path, _path2, _g, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHouseholdContentInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_832)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9996 24.844L35.0635 41.0937V78.2845H82.9358V41.0937L58.9996 24.844Z",
    fill: "#FED3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.04 58.3376H55.0108V78.2845H44.04V58.3376Z",
    fill: "#FDBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9814 67.3137H79.9442V71.3031H65.9814V67.3137Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9893 78.2846V64.3219L64.9839 61.3298L66.9786 64.3219V78.2846H62.9893Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9678 78.2846V64.3219L72.9625 61.3298L74.9571 64.3219V78.2846H70.9678Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9463 78.2846V64.3219L80.941 61.3298L82.9356 64.3219V78.2846H78.9463Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9917 49.3616H56.0076C54.3551 49.3616 53.0156 48.0222 53.0156 46.3696V40.3856C53.0156 38.733 54.3551 37.3936 56.0076 37.3936H61.9917C63.6443 37.3936 64.9837 38.733 64.9837 40.3856V46.3696C64.9837 48.0222 63.6443 49.3616 61.9917 49.3616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9837 42.3803H59.997V37.3936H58.0023V42.3803H53.0156V44.3749H58.0023V49.3616H59.997V44.3749H64.9837V42.3803Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0244 67.3137H52.0191V69.3084H50.0244V67.3137Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0664 70.3059H36.0611V78.2846H34.0664V70.3059Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0506 66.3164C40.0506 69.8968 37.8175 72.3004 35.0639 72.3004C32.3102 72.3004 30.0771 69.8968 30.0771 66.3164C30.0771 63.9786 32.2025 58.3177 33.6785 54.6684C34.1832 53.4207 35.9455 53.4207 36.4502 54.6684C37.9252 58.3177 40.0506 63.9786 40.0506 66.3164Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0801 77.2873C29.0801 76.5823 29.6516 76.0107 30.3567 76.0107H87.6439C88.349 76.0107 88.9205 76.5823 88.9205 77.2873V78.5192C88.9205 79.2243 88.349 79.7958 87.6439 79.7958H30.3567C29.6516 79.7958 29.0801 79.2243 29.0801 78.5193V77.2873Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5226 41.9774C86.1267 42.5608 85.3329 42.7129 84.7494 42.317L59.7171 25.3307C59.2843 25.037 58.7162 25.037 58.2835 25.3307L33.2511 42.317C32.6677 42.7129 31.8738 42.5608 31.478 41.9774L30.6715 40.7889C30.2757 40.2055 30.4277 39.4117 31.0111 39.0158L58.2835 20.5095C58.7162 20.2159 59.2843 20.2159 59.7171 20.5096L86.9895 39.0158C87.5729 39.4117 87.7249 40.2055 87.3291 40.7889L86.5226 41.9774Z",
    fill: "#4B4A50"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#FF7D23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(29 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHouseholdContentInsurance);
export default __webpack_public_path__ + "static/media/imgHouseholdContentInsurance.242b46fa731ee9c62a0919a42aeb2293.svg";
export { ForwardRef as ReactComponent };